import { CircularProgress, Grid, Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import useServices from '../../services/useServices';
import Fingerprint from 'fingerprintjs';
import ARSSecurityPage from './ARSSecurityPage'
import { setSessionData, updateManifestFile } from '../../utils/utils';

const ValidateAccount = () => {
    let { accountId, uniqueCode } = useParams();
    updateManifestFile(accountId, uniqueCode)

    const { getValidateAccount, get, put } = useServices()
    const navigate = useNavigate()
    const [isValid, setIsValid] = useState(true)
    const [loading, setLoading] = useState(true)
    const [alertOpen, setAlertOpen] = useState(false);
    const [accountName, setAccountName] = useState('');

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertOpen(false);
    };

    const validateAccount = async () => {
        try {
            // First attempt
            const resp = await getValidateAccount(`account/validateAccLink/${accountId}/${uniqueCode}`);
            handleValidationResponse(resp);
        } catch (error) {
            if (error.response?.status === 417) {
                console.log('Received 417 status, attempting retry...');
                try {
                    // Explicit second attempt
                    const retryResp = await getValidateAccount(`account/validateAccLink/${accountId}/${uniqueCode}`);
                    handleValidationResponse(retryResp);
                } catch (retryError) {
                    console.log('Retry failed:', retryError);
                    handleValidationError();
                }
            } else {
                console.log('Initial attempt failed:', error);
                handleValidationError();
            }
        }
    };

    const handleValidationResponse = (resp) => {
        setSessionData(accountId, 'userID');
        setSessionData(uniqueCode, 'token');
        setSessionData(resp.data.resp, 'userData');
        
        // Set account name from response
        if (resp.data.resp && resp.data.resp.accountName) {
            setAccountName(resp.data.resp.accountName);
        }
        
        if (resp.data.resp && typeof resp.data.resp.isPassphraseEnabled !== 'undefined') {
            setLoading(resp.data.resp.isPassphraseEnabled);
        } else {
            setLoading(false);
        }
    };

    const handleValidationError = () => {
        setIsValid(false);
        setLoading(false);
    };

    const validatePassphrase = async (data) => {
        try {
            const resp = await get(`/newservicecall/directCall/${accountId}/${data.passphrase||'test'}/validatePassphrase`);
            if (resp.status === 200) {
                setSessionData(data.id, 'securityID');
                navigate('/newrequest');
            } else {
                setAlertOpen(true);
            }
        } catch (error) {
            console.log(error);
            setAlertOpen(true);
        }
    };

    useEffect(() => {
        validateAccount()
        getFingerprint();
    }, [])

    const getFingerprint = async () => {
        const fp = new Fingerprint();
        const result = fp.get();
        setSessionData(result, 'uniqueDeviceId')
    };

    return (
        <>
            <Grid container justifyContent={'center'} alignItems="center" sx={{ minHeight: 300 }}>
                {!isValid ? (
                    <Box m={3}>Sorry, Your account is not valid...! Please contact the corresponding officer.</Box>
                ) : (
                    <ARSSecurityPage onSubmit={validatePassphrase} loading={loading} accountName={accountName}/>
                )}
            </Grid>

            <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleAlertClose}  anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
                <Alert onClose={handleAlertClose} severity="error" sx={{ width: '100%' }}>
                    Passphrase validation failed!
                </Alert>
            </Snackbar>
        </>
    )
}

export default ValidateAccount